import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NitroPanel, NitroGrids, NitroPlaceholder, NitroButton, NitroButtonGroup, NitroText, NitroLoading } from 'nitro-components';
import { union, difference, remove } from 'lodash';

import Container from '../../../../components/layouts/Container';
import FieldSelection from './components/FieldSelection';

const BUTTON_CONFIG = {
  available: {
    variant: 'primary',
    label: 'ADD SELECTED FIELDS TO TABLE',
    rightIcon: 'arrow-right'
  },
  selected: {
    variant: 'secondary',
    label: 'REMOVE SELECTED FIELDS FROM TABLE',
    leftIcon: 'arrow-left'
  }
};

class Fields extends Component {
  constructor(props) {
    super(props);
    const { fields, selectedFields } = props;
    const availableFields = difference(fields, selectedFields);
    this.state = {
      checkedAvailableFields: [],
      checkedSelectedFields: [],
      availableFields: availableFields, // allFields - selectedFields
      selectedFields: selectedFields // redux-selectedFields
    };
  }

  get navigationBar() {
    return {
      left: (
        <NitroButton
          labelVariant="secondary"
          action={this.props.navigation.goPrevious}
          label="PREVIOUS"
          size="extraSmall"
          leftIcon="arrow-left"
          leftIconVariant="secondary"
          insideIconSize={8}
        />
      ),
      middle: null,
      right: (
        <NitroButtonGroup layout="horizontal" align="right">
          <NitroButton
            action={this.props.navigation.goNext}
            label="SKIP"
            labelVariant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            rightIconVariant="primary"
            insideIconSize={8}
          />
          <NitroButton
            action={this.goNext}
            label="NEXT"
            variant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            insideIconSize={8}
          />
        </NitroButtonGroup>
      )
    };
  }

  componentDidMount() {
    this.props.setNavigation(this.navigationBar);
  }

  componentWillReceiveProps(nextProps) {
    const { fields, selectedFields } = nextProps;
    if(nextProps.fields !== this.props.fields || nextProps.selectedFields !== this.props.selectedFields) {
      const availableFields = difference(fields, selectedFields);
      this.setState({
        availableFields,
        selectedFields
      });
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   const { fields, selectedFields } = nextProps;
  //   const availableFields = difference(fields, selectedFields);
  //
  //   this.setState({
  //     availableFields,
  //     selectedFields
  //   });
  // }

  goNext = () => {
    this.props.actions.setSelectedFields(this.state.selectedFields);
    this.props.navigation.goNext();
  };

  displaySelectedFieldActionBar = (type, fields) => {
    const { selectedFields } = this.state;

    const moveSelected = () => this.moveSelected(type);

    const buttonConfig = BUTTON_CONFIG[type];
    this.props.setNavigation({
      left: (
        <NitroText size="3" variant="base2" bold>
          {fields.length} selected field
        </NitroText>
      ),
      middle: <NitroButton action={moveSelected} size="extraSmall" insideIconSize={8} {...buttonConfig} />,
      right: <NitroButton action={this.cancelSelected} labelVariant="base2" label="CANCEL" size="extraSmall" />
    });
  };

  moveSelected = type => {
    const { selectedFields, checkedAvailableFields, checkedSelectedFields } = this.state;
    const newSelectedFields =
      type === 'available'
        ? union(selectedFields, checkedAvailableFields)
        : difference(selectedFields, checkedSelectedFields);

    this.setState({
      selectedFields: newSelectedFields,
      availableFields: difference(this.props.fields, newSelectedFields)
    });
    this.cancelSelected();
  };

  changeSelectedFields = fields => {
    this.setState({
      checkedSelectedFields: fields
    });
    this.displaySelectedFieldActionBar('selected', fields);
  };

  changeAvailableFields = fields => {
    this.setState({
      checkedAvailableFields: fields
    });
    this.displaySelectedFieldActionBar('available', fields);
  };

  setSelectedFields = fields => {
    this.setState({
      selectedFields: fields
    });
    // const { actions } = this.props;
    // actions.setSelectedFields(fields);
  };

  cancelSelected = () => {
    this.available.reset();
    this.selected.reset();
    this.props.setNavigation(this.navigationBar);
  };

  render() {
    const { checkedSelectedFields, availableFields, checkedAvailableFields, selectedFields } = this.state;
    const { fetchingReportFields } = this.props;
    return (  
      <Container>
        <NitroPlaceholder size={20} />
       { !fetchingReportFields &&
        <NitroGrids>
          <FieldSelection
            ref={ref => (this.available = ref)}
            type="available"
            disabled={checkedSelectedFields.length > 0}
            fields={availableFields}
            header="All available fields"
            action={this.changeAvailableFields}
          />
          <FieldSelection
            ref={ref => (this.selected = ref)}
            type="selected"
            disabled={checkedAvailableFields.length > 0}
            fields={selectedFields}
            header="Added table fields"
            action={this.changeSelectedFields}
            arrange={this.setSelectedFields}
          />
        </NitroGrids>
      }
      { fetchingReportFields &&
        <NitroLoading />

      }
      </Container>
    );
  }
}
Fields.propTypes = {
  actions: PropTypes.object
};

export default Fields;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Fields/Fields.js